module.exports = __webpack_public_path__ + "img/mw20.f8be1ba2.jpg";